import {
  GET_CONTACT_REQUEST,
  GET_CONTACT_SUCCESS,
  GET_CONTACT_FAILURE,
  statusType
} from '../../actions'

const initial = {
  data: {},
  status: statusType.IDLE,
  initialLoading: true
}

const contact = (state = initial, action) => {
  const { payload } = action

  switch (action.type) {
    case GET_CONTACT_REQUEST:
      return {
        ...initial,
        status: statusType.IN_PROGRESS
      }

    case GET_CONTACT_SUCCESS:
      return {
        ...state,
        data: payload,
        status: statusType.SUCCESS,
        initialLoading: false
      }

    case GET_CONTACT_FAILURE:
      return {
        ...state,
        status: statusType.ERROR,
        initialLoading: false
      }

    default:
      return state
  }
}

export default contact
